import { ref, computed, onMounted } from 'vue';

import type { Reference } from '@/models/reference';
import type { SwiperContainer } from 'swiper/element';

export const useReferences = (references: Reference[]) => {
  const swiperRef = ref<SwiperContainer | null>(null);
  const isInitialized = ref(false);

  const shouldHideButtons = computed(() => (swiperRef.value?.swiper?.isBeginning && swiperRef.value?.swiper?.isEnd) || !references.length);

  const shouldDisableNext = ref(false);
  const shouldDisablePrev = ref(true);

  const next = () => {
    swiperRef.value?.swiper.slideNext();
  };

  const prev = () => {
    swiperRef.value?.swiper.slidePrev();
  };

  onMounted(() => {
    swiperRef.value?.initialize();
    isInitialized.value = true;
  });

  const fixedWidthOnLg = computed(() => {
    return references.length > 5;
  });

  const fixedWidthOnMd = computed(() => {
    return references.length > 3;
  });

  const fixedWidthOnSm = computed(() => {
    return references.length > 2;
  });

  const onSlideChange = () => {
    if (swiperRef.value) {
      shouldDisableNext.value = swiperRef.value.swiper.isEnd;
      shouldDisablePrev.value = swiperRef.value.swiper.isBeginning;
    }
  };

  return {
    swiperRef,
    shouldHideButtons,
    shouldDisableNext,
    shouldDisablePrev,
    fixedWidthOnLg,
    fixedWidthOnMd,
    fixedWidthOnSm,
    onSlideChange,
    isInitialized,
    next,
    prev
  };
};
